import React, { useState } from "react";
import BslApplyCard from "./BslApplyCard";
import SidebarNavItem from "./SidebarNavItem";
import SidebarSection from "./SidebarSection";
import SidebarSubsection from "./SidebarSubsection";
import {
  getCategoryKey,
  getPageFeatures,
  getSectionTitle,
} from "../utils/legalSidebar";

export default function SidebarCategory({
  category,
  activeKey,
  open,
  onToggle,
  disabled = false,
  bslApply = false,
  transactionsToApproveCount,
  onNavigate,
}) {
  const [openSubsections, setOpenSubsections] = useState({});
  const name = category?.Description || "";
  const categoryKey = getCategoryKey(category);
  const categoryActive = (Array.isArray(category?.Sections)
    ? category.Sections
    : []
  ).some((section) =>
    getPageFeatures(section).some((feature) => feature?.Slug === activeKey),
  );

  if (!category) return null;

  const renderFeature = (feature) => {
    const slug = feature?.Slug || "";
    const label = feature?.Description || slug;
    const count =
      slug.toLowerCase() === "pendingapprovals"
        ? transactionsToApproveCount
        : undefined;

    return (
      <SidebarNavItem
        key={`${categoryKey}-${feature?.FeatureID ?? slug}-${label}`}
        label={label}
        count={count}
        active={activeKey === slug}
        disabled={disabled}
        compact
        onClick={() => onNavigate(slug, slug)}
      />
    );
  };

  return (
    <SidebarSection
      title={name}
      logo={category?.Logo || ""}
      active={categoryActive}
      open={open}
      onToggle={onToggle}
    >
      {bslApply ? (
        <div className="new-sidebar-bsl-card">
          <BslApplyCard />
        </div>
      ) : (
        (Array.isArray(category?.Sections) ? category.Sections : []).map((section) => {
          const sectionItems = getPageFeatures(section);
          const sectionTitle = getSectionTitle(section?.Description);
          const sectionKey = section?.SectionID ?? sectionTitle ?? name;

          if (!sectionItems.length) return null;

          if (!sectionTitle || sectionTitle === "Overview") {
            return (
              <div className="new-sidebar-subsection" key={sectionKey}>
                {sectionTitle ? (
                  <div className="new-sidebar-subsection__title is-static">
                    {sectionTitle}
                  </div>
                ) : null}
                {sectionItems.map(renderFeature)}
              </div>
            );
          }

          return (
            <SidebarSubsection
              key={sectionKey}
              title={sectionTitle}
              className={
                String(sectionTitle || "").trim().toLowerCase() === "pay"
                  ? "is-pay-subsection"
                  : ""
              }
              open={!!openSubsections[sectionKey]}
              onToggle={() =>
                setOpenSubsections((current) => ({
                  ...current,
                  [sectionKey]: !current[sectionKey],
                }))
              }
            >
              {sectionItems.map(renderFeature)}
            </SidebarSubsection>
          );
        })
      )}
    </SidebarSection>
  );
}
